import React from 'react'
import { Footer1 } from '../../components/footers/Footer1'
import { Footer2 } from '../../components/footers/Footer2'

export default function FooterPage() {
  return (
    <div className="relative space-y-16 py-12 bg-gray-50 min-h-screen">
      <section className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b">Footer Showcase</h2>
        
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-12">
          <div className="p-4 bg-gray-100 border-b">
            <h3 className="font-medium text-gray-700">Footer 1</h3>
          </div>
          <div className="p-6">
            <Footer1 />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-4 bg-gray-100 border-b">
            <h3 className="font-medium text-gray-700">Footer 2</h3>
          </div>
          <div className="p-6">
            <Footer2 />
          </div>
        </div>
      </section>
    </div>
  )
}